/**
 * Used to validate input
 * @returns methods for validation
 */
export default function () {
  const EMAIL_REGEX = /^[\S._%+-]+@[\S.-]+\.[A-Za-z]{2,}$/;
  const URL_REGEX =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/i;

  /**
   * whether the given string is a valid email address
   * @param email email address in string
   * @returns true|false
   */
  function isValidEmail(email: string) {
    return EMAIL_REGEX.test(email.trim().toLowerCase());
  }

  /**
   * whether the given string is a valid url.
   * @param url url in string
   * @returns true|false
   */
  function isValidURL(url: string) {
    return URL_REGEX.test(url.trim());
  }

  return {
    isValidEmail,
    isValidURL,
  };
}
